import { render, staticRenderFns } from "./HeaderQuickPay.vue?vue&type=template&id=1f1558aa"
import script from "./HeaderQuickPay.vue?vue&type=script&lang=js"
export * from "./HeaderQuickPay.vue?vue&type=script&lang=js"
import style0 from "./HeaderQuickPay.vue?vue&type=style&index=0&id=1f1558aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports